export default __webpack_public_path__ + "static/media/Bipasha_Hossain_AHV_In_Moms_We_Trust.072cb547.jpg";